import * as jQuery from 'jquery';
import * as moment from 'moment';
// import { SortablejsOptions } from 'ngx-sortablejs';
import { Options as SortablejsOptions } from 'sortablejs';
import { fromEvent, Observable } from 'rxjs';
import * as _ from 'underscore';

import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ReportingConfig, ReportingConfigObject } from '../../../analytics-core/interfaces/widget.interface';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ModalService } from '../../../shared/directives/modal/modal.service';
import { SELECTION_COUNT, VALIDATION_MESSAGES } from './enterprise-reports-generator.constants';

@Component({
	selector: 'app-enterprise-reports-generator',
	styleUrls: ['./enterprise-reports-generator.component.css'],
	templateUrl: './enterprise-reports-generator.component.html'
})
export class EnterpriseReportsGeneratorComponent implements OnInit, OnDestroy {
	@ViewChild('searchSection') searchSection: ElementRef;
	@ViewChild('metricSection') metricSection: ElementRef;
	@Input() sectiontitle: string;
	@Input() key: string;
	@Input() reportingconfig: any;

	public attributes: ReportingConfigObject[];
	public metrics: ReportingConfigObject[];
	public validationMessages: string[] = [];
	public showEmailConfirmation = false;
	public emailConfirmationMessage = '';
	public searchMetric: string;
	public searchAttribute: string;
	public showAtrributes = false;
	public showMetrics = false;
	public selectedAttributes = [];
	public selectedMetrics = [];
	public widgetDataSubscription;
	public refreshSubscription;
	// tslint:disable-next-line: deprecation
	draggableOptions: SortablejsOptions = {
		draggable: '.draggable'
	};

	private unsubscribeEvent;
	private reportingConfiguration: ReportingConfig;
	private dataSource: string;

	constructor(
		private analyticsService: AnalyticsService,
		private analyticsDataModel: AnalyticsDataModel,
		private modalService: ModalService
	) {
		this.refreshSubscription = EmitterService.get(EVENT_EMITTERS.REFRESH_DATA_SOURCE).subscribe((response) => {
			this.filterAttributesAndMetricsByDataSource(response);
		});
	}

	ngOnInit(): void {
		this.reportingConfiguration = JSON.parse(decodeURI(this.reportingconfig));
		this.attributes = this.reportingConfiguration.attributes;
		this.metrics = this.reportingConfiguration.metrics;
	}

	@HostListener('document:click', ['$event'])
	clickout(event: any): void {
		if (this.searchSection && !this.searchSection.nativeElement.contains(event.target) && this.showAtrributes) {
			this.showAtrributes = false;
		}
		if (this.metricSection && !this.metricSection.nativeElement.contains(event.target) && this.showMetrics) {
			this.showMetrics = false;
		}
	}

	@HostListener('dragstart', ['$event'])
	dragstart(event: any): void {
		jQuery(event.target).addClass('highlighting-dragged-item');
	}

	@HostListener('dragend', ['$event'])
	dragend(event: any): void {
		jQuery(event.target).removeClass('highlighting-dragged-item');
	}

	onSearchFocus(type: any): void {
		switch (type) {
			case 'attribute':
				if (!this.showAtrributes) {
					setTimeout(() => {
						this.showAtrributes = true;
					}, 100);
				}
				break;
			case 'metrics':
				if (!this.showMetrics) {
					setTimeout(() => {
						this.showMetrics = true;
					}, 100);
				}
				break;
		}
	}

	onSearchFocusOut(type: any): void {
		switch (type) {
			case 'attribute':
				this.showAtrributes = false;
				break;
			case 'metrics':
				this.showMetrics = false;
				break;
		}
	}

	filterAttributesAndMetricsByDataSource(datasources: any[]): void {
		this.dataSource = datasources[0] ? datasources[0].name : '';
		this.attributes = _.filter(this.reportingConfiguration.attributes, (attribute) => {
			let selection = attribute.isGeneric;
			attribute.selected = false;
			for (const datasource of datasources) {
				selection = selection || attribute.dependentDataSource.indexOf(datasource.name) !== -1;
			}
			return selection;
		});
		this.metrics = _.filter(this.reportingConfiguration.metrics, (metric) => {
			let selection = metric.isGeneric;
			metric.selected = false;
			for (const datasource of datasources) {
				selection = selection || metric.dependentDataSource.indexOf(datasource.name) !== -1;
			}
			return selection;
		});
		this.selectedAttributes = [];
		this.selectedMetrics = [];
	}

	updateSelectedDataToList(type: any, data: any): void {
		this[type] = this[type].filter((item) => {
			return item.key !== data.key;
		});
	}

	addToSelectedAttributeList(attribute: any): void {
		if (attribute.selected === true) {
			this.selectedAttributes.push(attribute);
		} else {
			this.updateSelectedDataToList('selectedAttributes', attribute);
		}
	}

	addToSelectedMetricsList(metric: any): void {
		if (metric.selected === true) {
			this.selectedMetrics.push(metric);
		} else {
			this.updateSelectedDataToList('selectedMetrics', metric);
		}
	}

	updateReportingConfiguration(type: any, data: any): void {
		this.reportingConfiguration[type] = this.reportingConfiguration[type].map((item) => {
			if (item.key === data.key) {
				item.selected = false;
			}
			return item;
		});
	}

	removeSelectedAttribute(attribute: any): void {
		this.selectedAttributes = this.selectedAttributes.filter((item) => {
			return item.key !== attribute.key;
		});

		this.updateReportingConfiguration('attributes', attribute);
	}

	removeSelectedMetric(metric: any): void {
		this.selectedMetrics = this.selectedMetrics.filter((item) => {
			return item.key !== metric.key;
		});
		this.updateReportingConfiguration('metrics', metric);
	}

	generateCustomReport(): void {
		const selectedAttributeKeys = _.pluck(this.selectedAttributes, 'key');
		const selectedMetricKeys = _.pluck(this.selectedMetrics, 'key');
		this.emailConfirmationMessage = VALIDATION_MESSAGES.SUCCESS;

		if (this.validateCustomReport(this.selectedAttributes, this.selectedMetrics)) {
			this.showEmailConfirmation = true;
			this.emailConfirmationMessage += this.analyticsDataModel.user.email + '.';
			this.openModal('custom-reports-widget-error');
			setTimeout(() => {
				this.emailSubscription(selectedAttributeKeys, selectedMetricKeys);
			}, 100);
		} else {
			this.showEmailConfirmation = false;
			this.openModal('custom-reports-widget-error');
		}
	}

	emailSubscription(attributekeys: any, metricKeys: any): void {
		const node = document.querySelector('#email-report');
		const input$ = fromEvent(node, 'click');
		this.unsubscribeEvent = input$.subscribe({
			error: (err) => console.log(`Oops... ${err}`),
			next: (event) => this.processCustomReportRequest(attributekeys, metricKeys)
		});
	}

	processCustomReportRequest(selectedAttributeKeys: any, selectedMetricKeys: any): void {
		this.closeModal('custom-reports-widget-error');
		this.showEmailConfirmation = false;
		this.widgetDataSubscription = this.analyticsService
			.processCustomReporting(selectedAttributeKeys, selectedMetricKeys, this.dataSource, this.key)
			.subscribe((response: any) => {
				if (!response.success) {
					this.validationMessages = [];
					this.validationMessages.push(VALIDATION_MESSAGES.RESPONSE_ERROR);
					this.openModal('custom-reports-widget-error');
				}
				this.unsubscribeEvent.unsubscribe();
			});
	}

	validateCustomReport(selectedAttributes: any, selectedMetrics: any): boolean {
		this.validationMessages = [];
		const selectedAdvertisers = this.analyticsDataModel.selectedAdvertisers;
		const selectedCampaigns = this.analyticsDataModel.selectedCampaigns;
		const startDate = this.analyticsDataModel.startDate;
		const endDate = this.analyticsDataModel.endDate;

		// Validate Attributes and Metrics
		if (selectedAttributes.length < SELECTION_COUNT.ATTRIBUTES && selectedMetrics.length < SELECTION_COUNT.METRICS) {
			this.validationMessages.push(VALIDATION_MESSAGES.MIN_METRIC_AND_ATTRIBUTE_ERROR);
		} else {
			if (this.attributes.length > 0 && selectedAttributes.length < SELECTION_COUNT.ATTRIBUTES) {
				this.validationMessages.push(VALIDATION_MESSAGES.MIN_ATTRIBUTE_ERROR);
			} else if (this.metrics.length > 0 && selectedMetrics.length < SELECTION_COUNT.METRICS) {
				this.validationMessages.push(VALIDATION_MESSAGES.MIN_METRIC_ERROR);
			}
		}
		// Validate Advertisers
		if (selectedAdvertisers.length < SELECTION_COUNT.ADVERTISERS) {
			this.validationMessages.push(VALIDATION_MESSAGES.MIN_ADVERTISER_ERROR);
		}
		// Validate Campaigns
		if (selectedCampaigns.length < SELECTION_COUNT.CAMPAIGNS) {
			this.validationMessages.push(VALIDATION_MESSAGES.MIN_CAMPAIGN_ERROR);
		}
		// Validate start and end date
		if (!moment(startDate).isSameOrBefore(moment(endDate))) {
			this.validationMessages.push(VALIDATION_MESSAGES.MIN_DATE_ERROR);
		}
		// Validate date range
		const dateDiff = moment(endDate).diff(moment(startDate), 'days');

		if (dateDiff > SELECTION_COUNT.MAX_YEAR_DAYS_RANGE) {
			this.validationMessages.push(VALIDATION_MESSAGES.YEAR_RANGE_ERROR);
		} else if (dateDiff <= SELECTION_COUNT.MAX_YEAR_DAYS_RANGE && dateDiff > SELECTION_COUNT.MAX_DATE_RANGE) {
			if (selectedAttributes.length > 5) {
				this.validationMessages.push(VALIDATION_MESSAGES.ATTRIBUTE_LENGTH_ERROR);
			}
		} else {
			if (dateDiff > SELECTION_COUNT.MAX_DATE_RANGE) {
				this.validationMessages.push(VALIDATION_MESSAGES.DATE_RANGE_ERROR);
			}
		}

		return this.validationMessages.length === 0;
	}

	openModal(id: string): void {
		this.modalService.open(id);
	}

	closeModal(id: string): void {
		this.modalService.close(id);
	}

	ngOnDestroy(): void {
		this.validationMessages = [];
		this.attributes = [];
		this.metrics = [];
		this.reportingConfiguration = {} as ReportingConfig;
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
		if (this.refreshSubscription) {
			this.refreshSubscription.unsubscribe();
		}
	}
}
